import { render, staticRenderFns } from "./remoteUpgrade.vue?vue&type=template&id=2161787a&scoped=true&"
import script from "./remoteUpgrade.vue?vue&type=script&lang=js&"
export * from "./remoteUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./remoteUpgrade.vue?vue&type=style&index=0&id=2161787a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161787a",
  null
  
)

export default component.exports